import ConfirmationModal from "../components/ConfirmationModal";

// The delete confirm the list pages open from a row's delete button. It is a thin
// preset over ConfirmationModal — same dialog as everywhere else in the admin, with
// the destructive tone and wording already filled in — so a list page only supplies
// what is being deleted.
const AdminDeleteModal = ({
  show,
  title = "Delete this item?",
  message,
  confirmLabel = "Delete",
  onCancel,
  onConfirm,
}) => (
  <ConfirmationModal
    show={show}
    title={title}
    description={message}
    variant="danger"
    confirmLabel={confirmLabel}
    onCancel={onCancel}
    onConfirm={onConfirm}
  />
);

export default AdminDeleteModal;
